import React from "react";

export default function InfiniteZombiePlanner({ children }) {
  return <>{children}</>;
}

